const OpenFullScreenIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.8535 3.70703V6.5H13.8535V2H9.35352V3H12.1465L8 7.14648L8.70703 7.85352L12.8535 3.70703Z'
        fillRule='evenodd'
        stroke='none'
      />
      <path
        d='M3 12.1465V9.35352H2V13.8535H6.5V12.8535H3.70703L7.85352 8.70703L7.14648 8L3 12.1465Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default OpenFullScreenIcon;
